export default __webpack_public_path__ + "static/later-board-m-609bc363083177940cedbcf8c2175ed9.webp";